import { LoaderActions } from '@store/loaders'
import {
  type DashboardActions,
  InternalProjectActions as Internal,
} from '@store/reducers/dashboard/actions'
import { selectProjectParents } from '@store/reducers/dashboard/selectors'
import {
  PROJECTS_LIMIT_REACHED,
  upgradeToast,
} from '@store/reducers/limitReached'
import {
  ErrorNotification,
  notificationActionCreators,
} from '@storeOld/reducers/notification'
import { call, put, select } from 'redux-saga/effects'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { NestClient } from '@/nest'
import type { ProjectParents } from '../../types'
import { parseNestError } from '../../utils'

export function* unarchive({
  payload: { id },
}: ReturnType<typeof DashboardActions.projects.unarchive>) {
  const path: ProjectParents | null = yield select(selectProjectParents(id))

  if (!path) {
    return
  }

  const { project, workspace } = path

  const folderId = path.project.folderId || ''

  yield put(LoaderActions.set(id))

  sendGtmEvent(GtmTriggerName.PROJECT_UNARCHIVE)

  try {
    yield call(NestClient.projects.unarchive, { ids: [id] })
    yield put(Internal.delete({ id }))

    yield put(
      Internal.add({
        workspaceId: workspace.id,
        folderId,
        project: { ...path.project, archived: false },
      })
    )

    yield put(
      notificationActionCreators.setCustomNotification({
        toastContainerId: 'secondary',
        type: 'gray',
        text: `${project.title} unarchived`,
      })
    )
  } catch (e) {
    const message = parseNestError(e)

    if (message === PROJECTS_LIMIT_REACHED) {
      yield* upgradeToast(message)

      return
    }

    yield put(ErrorNotification(message))
  } finally {
    yield put(LoaderActions.unset(id))
  }
}
